import { jsx as _jsx } from "react/jsx-runtime";
import { LayoutTemplateViewContainer } from './LayoutTemplateViewContainer';
import { useViewContainer } from './useViewContainer';
export const BasicViewContainer = () => {
  const {
    ViewComponent,
    viewContainerProps
  } = useViewContainer();

  if (!ViewComponent) {
    return null;
  }

  return /*#__PURE__*/_jsx(LayoutTemplateViewContainer, Object.assign({
    StepViewComponent: ViewComponent
  }, viewContainerProps));
};